<template>
  <div>
    <nav-bar-top icons-are-hidden is-primary />
    <div class="container has-nav-top-margin">
      <section class="section sign-up-form-container">
        <sign-up-candidate-form-card />
      </section>
    </div>
  </div>
</template>

<script>
import NavBarTop from '@/components/Navigation/NavBarTop';
import SignUpCandidateFormCard from '@/components/SignUp/SignUpCandidateFormCard';

export default {
  name: 'SignUpCandidateView',
  components: {
    SignUpCandidateFormCard,
    NavBarTop
  }
};
</script>

<style lang="scss" scoped>
.sign-up-form-container {
  max-width: 500px;
  margin: 0 auto;
}
</style>
